<!-- side-bar single product slider start -->
<div class="theme-card">
  <h5 class="title-border">SẢN PHẨM MỚI</h5>
  <owl-carousel-o [options]="NewProductSliderConfig" class="offer-slider">
    <ng-container *ngFor="let product of products | slice:0:3 ">
      <ng-template carouselSlide>
        <div>
          <div class="d-flex align-items-center" *ngFor="let product of products | slice:0:3 ">
            <a (click)="goToProduct(product.id)">
              <img class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'"
                [lazyLoad]="product.images[0].imageUrl" alt="">
            </a>
            <div class="media-body align-self-center">
              <bar-rating [rate]="product.averageRating" [readOnly]="true"></bar-rating>
              <a (click)="goToProduct(product.id)">
                <h6>{{ product.name | titlecase }}</h6>
              </a>
              <h4>
                {{ product?.cost - (product?.cost * product.discountPercent / 100) | currency:'VND' }}
                <del *ngIf="product?.discountPercent > 0">
                  <span class="money">
                    {{ product?.cost | currency:'VND' }}
                  </span>
                </del>
              </h4>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div>
          <div class="d-flex align-items-center" *ngFor="let product of products | slice:3:6 ">
            <a (click)="goToProduct(product.id)">
              <img class="img-fluid w-auto" [defaultImage]="'assets/images/product/placeholder.jpg'"
                [lazyLoad]="product.images[0].imageUrl" alt="">
            </a>
            <div class="media-body align-self-center">
              <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
              <a (click)="goToProduct(product.id)">
                <h6>{{ product.name | titlecase }}</h6>
              </a>
              <h4>
                {{ product?.cost - (product?.cost * product.discountPercent / 100) | currency:'VND' }}
                <del *ngIf="product?.discountPercent > 0">
                  <span class="money">
                    {{ product?.cost | currency:'VND' }}
                  </span>
                </del>
              </h4>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>
<!-- side-bar single product slider end -->